import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import withTranslation from "../../hocs/withTranslation";

const ArnoldToast = ({ notification, dismiss, t }) => (
    <div className="overflow-hidden rounded-card border border-border bg-surface shadow-lg">
        <div className="flex items-center justify-between gap-2 border-b border-border bg-surface-2 px-3 py-2">
            <span className="text-sm font-medium text-ink">{t("messages.notification.title")}</span>
            <button
                type="button"
                onClick={() => dismiss(notification)}
                aria-label="close"
                className="flex h-6 w-6 appearance-none items-center justify-center rounded-full! border-0 bg-transparent p-0 text-ink-muted hover:bg-surface-3 hover:text-ink"
            >
                <FontAwesomeIcon icon={faXmark} className="text-xs" />
            </button>
        </div>
        <div className="px-3 py-2 text-sm text-ink">
            {notification.text || t(notification.translatedText)}
        </div>
    </div>
);

ArnoldToast.propTypes = {
    notification: PropTypes.shape({
        text: PropTypes.string,
        translatedText: PropTypes.string,
    }).isRequired,
    dismiss: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default withTranslation(ArnoldToast);
